import { render, staticRenderFns } from "./add-auth.vue?vue&type=template&id=aa41ed7a"
import script from "./add-auth.vue?vue&type=script&lang=ts"
export * from "./add-auth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports